/* @license magnet:?xt=urn:btih:0b31508aeb0634b347b8270c7bee4d411b5d4109&dn=agpl-3.0.txt AGPL-3.0 */
import UploadHistory from "./history.js";
import { translate } from "./translations.js";

window.addEventListener("DOMContentLoaded", () => {
  const dropArea = document.getElementById("drop-area");
  const fileInput = document.getElementById("file");
  const uploadStatus = document.getElementById("upload-status-container");
  const history = new UploadHistory();

  // i18n
  const translate_uploadText = translate("js_upload_text");
  const translate_uploadClientError = translate("js_upload_client_error");
  const translate_uploadServerError = translate("js_upload_server_error");
  const translate_uploadUnknownError = translate("js_upload_unknown_error");
  const translate_DeleteError = translate("js_history_delete_error");
  const translate_DeleteSuccess = translate("js_history_delete_success");
  const translate_DeletingFile = translate("js_history_delete_deleting_file");
  const translate_LinkCopied = translate("js_generic_link_copied_to_clipboard");
  const translate_buttonDelete = translate("js_btn_delete");
  const translate_buttonCopy = translate("js_btn_copy");
  const translate_buttonCancelUpload = translate("js_btn_cancel_upload");
  const translate_status_uploading = translate("js_status_uploading");
  const translate_status_cancelled = translate("js_status_cancelled");
  const translate_speed = translate("js_speed");

  const dropAreaText = document.createElement("p");
  dropAreaText.textContent = translate_uploadText;
  dropArea?.appendChild(dropAreaText);
  fileInput?.setAttribute("multiple", "");
  dropArea?.addEventListener("click", () => fileInput?.click());

  fileInput?.addEventListener(
    "change",
    () => {
      const files = fileInput.files;
      handleFiles(files);
    },
    false,
  );

  ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
    window.addEventListener(eventName, preventDefaults, false);
  });

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  document.addEventListener("paste", handlePaste, false);
  document.addEventListener("drop", handleDrop, false);

  function handleDrop(e) {
    const dt = e.dataTransfer;
    const files = dt.files;
    handleFiles(files);
  }

  function handlePaste(e) {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind === "file") {
        const file = item.getAsFile();
        handleFiles([file]);
      }
    }
  }

  function handleFiles(files) {
    if (files.length > 0) {
      for (const file of files) {
        uploadFile(file);
      }
    }
  }

  function uploadFile(file) {
    const url = "/-/upload";
    const xhr = new XMLHttpRequest();

    const uploadContainer = document.createElement("div");
    const statusLink = document.createElement("div");
    const uploadText = document.createElement("a");
    const percentText = document.createElement("span");
    const speedText = document.createElement("span");
    const rightButtons = document.createElement("div");
    const leftButtons = document.createElement("div");
    const copyButton = document.createElement("button");
    const deleteButton = document.createElement("button");
    const cancelUploadButton = document.createElement("button");

    uploadContainer.className = "upload-status";
    uploadContainer.id = "upload-status";
    rightButtons.className = "buttons-container right-buttons";
    leftButtons.className = "buttons-container left-buttons";
    rightButtons.appendChild(copyButton);
    rightButtons.appendChild(cancelUploadButton);
    leftButtons.appendChild(deleteButton);
    uploadContainer.appendChild(leftButtons);
    uploadText.appendChild(percentText);
    uploadText.appendChild(speedText);
    uploadContainer.appendChild(uploadText);
    uploadContainer.appendChild(statusLink);
    uploadContainer.appendChild(rightButtons);
    uploadStatus?.appendChild(uploadContainer);

    percentText.innerHTML = "0%";
    uploadText.className = "percent";
    speedText.className = "speed";
    speedText.style.marginLeft = "6px";
    speedText.style.display = "none";
    statusLink.className = "status";
    copyButton.className = "button copy-button";
    copyButton.innerHTML = translate_buttonCopy;
    deleteButton.className = "button delete-button";
    deleteButton.innerHTML = translate_buttonDelete;
    cancelUploadButton.className = "button cancel-upload-button";
    cancelUploadButton.innerHTML = translate_buttonCancelUpload;
    copyButton.style.display = "none";
    deleteButton.style.display = "none";
    cancelUploadButton.style.display = "none";
    leftButtons.style.display = "none";

    let lastLoadTime = 0;
    let lastLoaded = 0;

    function formatSpeed(bytesPerSecond) {
      if (!Number.isFinite(bytesPerSecond) || bytesPerSecond <= 0) {
        return "";
      }
      const bitsPerSecond = bytesPerSecond * 8;
      if (bitsPerSecond >= 1000 * 1000) {
        return `(${(bitsPerSecond / (1000 * 1000)).toFixed(2)} Mbps)`;
      }
      return `(${(bitsPerSecond / 1000).toFixed(1)} Kbps)`;
    }

    xhr.upload.addEventListener("loadstart", (_) => {
      cancelUploadButton.style.display = "inline";
      statusLink.innerHTML = `<a>${translate_status_uploading}</a>`;
      speedText.style.display = "inline";
      cancelUploadButton.addEventListener(
        "click",
        () => {
          xhr.abort();
          statusLink.innerHTML = `<a>${translate_status_cancelled}</a>`;
          percentText.innerHTML = "-";
          speedText.style.display = "none";
        },
        { once: true },
      );
    });

    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable) {
        const percentComplete = Math.round((e.loaded / e.total) * 100);
        percentText.innerHTML = `${percentComplete}%`;

        const now = performance.now();
        const elapsed = (now - lastLoadTime) / 1000;
        if (lastLoadTime > 0 && elapsed > 0.25) {
          const bytesPerSecond = (e.loaded - lastLoaded) / elapsed;
          const speed = formatSpeed(bytesPerSecond);
          if (speed) {
            speedText.textContent = `${translate_speed} ${speed}`;
          }
          lastLoadTime = now;
          lastLoaded = e.loaded;
        } else if (lastLoadTime === 0) {
          lastLoadTime = now;
          lastLoaded = e.loaded;
        }
      }
    });

    xhr.onerror = () => {
      console.error("Error:", xhr.status, xhr.statusText, xhr.responseText);
      statusLink.textContent = translate_uploadUnknownError;
      cancelUploadButton.style.display = "none";
      percentText.innerHTML = "-";
      speedText.style.display = "none";
    };

    xhr.onload = () => {
      let deleteKey;
      cancelUploadButton.style.display = "none";
      if (xhr.status === 200) {
        try {
          const response = xhr.responseText;
          const parsedResponse = JSON.parse(response);
          const fileLink = parsedResponse.link;
          const deleteLink = parsedResponse.deleteLink;
          deleteKey = parsedResponse.deleteKey;
          statusLink.innerHTML = `<a href="${fileLink}" target="_blank">${fileLink}</a>`;
          copyButton.style.display = "";
          deleteButton.style.display = "";
          leftButtons.style.display = "";
          uploadText.style.display = "none";
          copyButton.onclick = () => copyToClipboard(fileLink, copyButton);
          deleteButton.onclick = () =>
            deleteFile(deleteLink, deleteKey, statusLink);
          history.add(response);
        } catch (_) {
          statusLink.textContent = translate_uploadUnknownError;
          cancelUploadButton.style.display = "none";
          percentText.innerHTML = "-";
          speedText.style.display = "none";
        }
      } else if (xhr.status >= 400 && xhr.status < 500) {
        statusLink.textContent = translate_uploadClientError;
        cancelUploadButton.style.display = "none";
      } else {
        statusLink.textContent = translate_uploadServerError;
        cancelUploadButton.style.display = "none";
      }
    };

    // Send file
    const formData = new FormData();
    formData.append("file", file);
    xhr.open("POST", url, true);
    xhr.send(formData);
  }

  function deleteFile(deleteLink, deleteKey, statusLink) {
    const url = deleteLink;
    const xhr = new XMLHttpRequest();

    xhr.onerror = () => {
      console.error(
        "Error deleting file:",
        xhr.status,
        xhr.statusText,
        xhr.responseText,
      );
      statusLink.textContent = translate_DeleteError;
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        statusLink.textContent = translate_DeleteSuccess;
        history.delete(deleteKey);
      }
    };

    xhr.open("GET", url, true);
    xhr.send();
  }

  function copyToClipboard(text, copyButton) {
    navigator.clipboard.writeText(text);
    const prevState = copyButton.innerHTML;
    copyButton.innerHTML = translate_LinkCopied;
    copyButton.innerHTML = translate_LinkCopied;
    setTimeout(() => {
      copyButton.innerHTML = prevState;
    }, 2000);
  }
});
/* @license-end */
